import { mapGetters, mapActions } from 'vuex'
import {
  matchStatusTransformer,
  reverseFormeArray
} from '@/utils/matchStatusTransformer'

import SheetWrapper from '@/components/SheetWrapper/index'
import InfoBadge from '@/components/InfoBadge/index'

import { formatTimestamp } from '@/utils/dateHelpers'

const FINISHED_SHORT_CODE = 'FT'

export default {
  components: {
    SheetWrapper,
    InfoBadge
  },
  props: {
    dateParam: String,
    pageArr: Array
  },
  methods: {
    ...mapActions({
      matchStatusAction: 'TRANSORM_MATCH_STATUS'
    }),
    ...mapActions('league', {
      fetchFixturesAction: 'FETCH_FIXTURES'
    }),
    handleColor(data) {
      return matchStatusTransformer(data)
    },
    handleForme(data) {
      return reverseFormeArray(data)
    },
    getTeamImage(iconSrc) {
      return iconSrc === 'Not available in Demo' || iconSrc === null
        ? require('@/assets/profile-avatar.svg')
        : iconSrc
    },
    convertTimeStamp(data) {
      const { original, local, dayDiff, isSame, numSign } = formatTimestamp({
        timestamp: data,
        formatTo: 'HH:mm'
      })
      const localTimeDisplay = `(${local}) ${
        dayDiff === 0 ? '' : numSign + dayDiff
      }`
      return {
        original,
        local: isSame ? '' : localTimeDisplay
      }
    },
    isFinished: data => data === FINISHED_SHORT_CODE
  },
  computed: {
    ...mapGetters({
      matchStatus: 'MATCH_STATUS_AVAILABILITY'
    }),
    ...mapGetters('league', {
      fixtures: 'FIXTURES'
    })
  },
  data: () => ({
    matches: null
  }),
  watch: {
    pageArr(pageList) {
      const dateParam =
        this.dateParam ||
        (pageList.find(item => item.defaultPage) &&
          pageList.find(item => item.defaultPage).param) ||
        pageList[0].param
      this.fetchFixturesAction(dateParam).then(() => {
        const { success, data } = this.fixtures
        this.matches = success && data
      })
    }
  }
}
